import { Link as RouterLink } from 'react-router-dom';
import React from 'react';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { DateTimeFormat, formatDateTime, parseDate } from '@occc-app/lib/date';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Link } from '@occc-app/design-system';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { routeCreator as membershipRouterCreator } from '@occc-app/routes/Member/utils';
import { ReferralInfoFragment } from '@occc/graphql';
import { TableField } from '@occc/ui-design-system';

import { membershipReferralsTableHeaderMessages as headerMessages } from './membership-referrals-table.messages';

export const formatTableDate = (date: string | null | undefined) => {
  if (!date) return '-';
  return formatDateTime(parseDate(date), DateTimeFormat.DateWithYear);
};

export const getReceiverDisplayName = (receiver: ReferralInfoFragment['receiver']) => {
  return [receiver.firstName, receiver.lastName].filter(Boolean).join(' ') || receiver.phone;
};

export const makeFields = (referral: ReferralInfoFragment): TableField[] => {
  const { createdAt, senderAwardGrantedDate, receiverAwardGrantedDate, receiver } = referral;
  return [
    {
      label: headerMessages.signUpDate,
      value: formatTableDate(createdAt),
    },
    {
      label: headerMessages.receiver,
      value: (
        <Link
          underline='none'
          component={RouterLink}
          to={membershipRouterCreator.details(receiver.id)}
        >
          {getReceiverDisplayName(receiver)}
        </Link>
      ),
    },
    {
      label: headerMessages.senderAwardGrantedDate,
      value: formatTableDate(senderAwardGrantedDate),
    },
    {
      label: headerMessages.receiverAwardGrantedDate,
      value: formatTableDate(receiverAwardGrantedDate),
    },
  ];
};
